export default __webpack_public_path__ + "static/slide04-c8855bcafab80816b3e5f1a6fdba54c1.png";